import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Container, Stack, Typography, Paper, Chip, Button } from '@mui/material';
import { useEffect, useState } from 'react';
import { DashboardLayout } from 'layouts/dashboard/DashboardLayout';
import { fetchDevice } from 'store/actions/deviceActions';
import { CircularProgress } from '@mui/material';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import DeviceInfo from './DeviceInfo';
import DeviceSchedule from './DeviceSchedule';
import TargetInfo from './TargetInfo';
import GroupInfo from './GroupInfo';
import DeviceReadings from './DeviceReadings';

const DeviceDetail = () => {
  const { serialKey } = useParams();
  const dispatch = useDispatch();
  const [readingsRefreshKey, setReadingsRefreshKey] = useState(0);

  useEffect(() => {
    dispatch({ type: fetchDevice.request, payload: { serialKey } });
  }, [dispatch, serialKey]);

  const device = useSelector((state: any) =>
    state.device.devices.find((device: any) => device.serial === serialKey),
  );

  if (!device) {
    return (
      <Box display='flex' justifyContent='center' alignItems='center' minHeight='200px'>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <DashboardLayout>
      <Box
        component='main'
        sx={{
          flexGrow: 1,
          py: 8,
          backgroundColor: '#f5f5f5',
        }}
      >
        <Container maxWidth='lg'>
          <Stack spacing={4}>
            <Paper elevation={3} sx={{ p: 3, borderRadius: 2 }}>
              <Stack
                direction={{ xs: 'column', md: 'row' }}
                spacing={3}
                alignItems='center'
                justifyContent='space-between'
              >
                <Stack spacing={1}>
                  <Typography variant='h4' fontWeight='bold'>
                    Device Details
                  </Typography>
                  <Stack direction='row' spacing={1} alignItems='center' flexWrap='wrap'>
                    <Typography variant='subtitle1' color='text.secondary'>
                      Serial: {device.serial}
                    </Typography>
                    <Chip
                      label={device.type.toUpperCase()}
                      color={device.type === 'automatic' ? 'success' : 'primary'}
                      size='small'
                      sx={{ fontWeight: 'bold' }}
                    />
                    <Chip
                      label={device.version || 'v3'}
                      size='small'
                      variant='outlined'
                      sx={{ fontWeight: 'bold' }}
                    />
                  </Stack>
                </Stack>
                <Button
                  variant='contained'
                  color='primary'
                  startIcon={<MonitorHeartIcon />}
                  href={`https://spa-status-ynbjf.ondigitalocean.app/?device_id=${encodeURIComponent(
                    device.device_key,
                  )}`}
                  target='_blank'
                  rel='noopener noreferrer'
                  sx={{ fontWeight: 'bold', px: 2.5 }}
                >
                  Device Health
                </Button>
              </Stack>
            </Paper>

            <Stack spacing={2}>
              <DeviceReadings device={device} refreshKey={readingsRefreshKey} />
              <DeviceInfo
                device={device}
                onFormulaApplied={() => setReadingsRefreshKey((key) => key + 1)}
              />
              <DeviceSchedule device={device} />
              <GroupInfo device={device} />
              <TargetInfo device={device} />
            </Stack>
          </Stack>
        </Container>
      </Box>
    </DashboardLayout>
  );
};

export default DeviceDetail;
